import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

import { Title, Meta, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-galerianueva',
  templateUrl: './galerianueva.component.html',
  styleUrls: ['./galerianueva.component.scss']
})

export class GalerianuevaComponent implements OnInit {

  title = '';
  description = '';



  constructor( private titleService: Title, private metaTagService: Meta, ) {
  }




  ngOnInit(): void {
    this.title = 'Galería de ganadores | Sorteo Anáhuac 2026 - 11ª Edición';
    this.titleService.setTitle(this.title);
    this.metaTagService.updateTag(
      { name: 'title', content: this.title }
    );
    this.metaTagService.updateTag(
      { name: 'description', content: this.description }
    );

    this.metaTagService.updateTag(
      { property: 'keywords', content: '' }
    );

    this.metaTagService.updateTag(
      { property: 'og:title', content: this.title }
    );

    this.metaTagService.updateTag(
      { property: 'og:description', content: this.description }
    );

    this.metaTagService.updateTag(
      { property: 'og:url', content: environment.URL_WEB + '/ganadores' }
    );

    this.metaTagService.updateTag(
      { property: 'og:image', content: environment.URL_WEB + '/assets/images/gallery-ph.jpg' }
    );

    this.metaTagService.updateTag(
      { name: 'twitter:title', content: this.title }
    );
    this.metaTagService.updateTag(
      { name: 'twitter:description', content: this.description }
    );



  }


}
